<template>
  <el-menu-item v-if="!menu.children" :index="menu.name" @click="push(menu)">
    <i v-if="menu.meta.icon" :class="menu.meta.icon"></i>
    <span>{{ menu.meta.title }}</span>
  </el-menu-item>

  <el-submenu v-else-if="menu.children" :index="menu.name">
    <span slot="title">
      <i v-if="menu.meta.icon" :class="menu.meta.icon"></i>
      <span>{{ menu.meta.title }}</span>
    </span>
    <item v-for="child in menu.children" :key="child.name" :menu="child"></item>
  </el-submenu>
</template>

<script>
export default {
  name: 'item',
  props: {
    menu: {
      type: Object,
      default: function () {
        return null
      }
    }
  },
  methods: {
    push({ path }) {
      this.$router.push(path)
    }
  }
}
</script>
